"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const UI_1 = require("~/components/UI");
const react_i18next_1 = require("react-i18next");
const selectors_1 = require("~/store/selectors");
const accessUtils_1 = require("~/utils/accessUtils");
const events_1 = require("~/utils/events");
const project_1 = require("~/store/api/project");
function BOMShareButton({ disabled }) {
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const project = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const [busy, setBusy] = (0, react_1.useState)(false);
    const pending = (0, react_1.useRef)(false);
    const canShare = Boolean((project === null || project === void 0 ? void 0 : project.id) && (0, accessUtils_1.canUserManageProjectSharing)(user, project));
    const copyLink = () => __awaiter(this, void 0, void 0, function* () {
        if (disabled || !canShare || !project || pending.current) {
            return;
        }
        pending.current = true;
        setBusy(true);
        try {
            const share = yield (0, project_1.createProjectShare)(project.id, 'view');
            const url = new URL(`/projects/${project.id}`, window.location.origin);
            url.hash = new URLSearchParams({ share: share.token }).toString();
            try {
                yield navigator.clipboard.writeText(url.toString());
                (0, events_1.showNotification)({ message: t('bom.sharing.copied'), type: 'success' });
            }
            catch (_a) {
                (0, events_1.showNotification)({ message: t('bom.sharing.copy-failed'), type: 'warning' });
            }
        }
        catch (_b) {
            (0, events_1.showNotification)({ message: t('bom.sharing.failed'), type: 'warning' });
        }
        finally {
            pending.current = false;
            setBusy(false);
        }
    });
    return (react_1.default.createElement(UI_1.Button, { disabled: disabled || busy || !canShare, onClick: copyLink }, t('bom.share')));
}
exports.default = BOMShareButton;
